export const thumbnailTransformer = (imageUrl: string, alternate = false) => {
  return `<div class="datatable__thumbnail-wrapper ${alternate ? 'datatable__thumbnail-wrapper--alternate' : ''}">
    <img class='datatable__thumbnail' src='${imageUrl}' />
  </div>`;
}
